define('Inspiredrooms.ei1.Main.Model',
[
    'SCModel',
    'Utils'
],
function
(
    SCModelModule,
    Utils
) {
    'use strict';
 
    var SCModel = SCModelModule.SCModel;
 
    function InspiredroomsModel () {
        SCModel.call(this);
 
        this.urlRoot = function urlRoot () {
            return Utils.getAbsoluteUrl(
                getExtensionAssetsPath(
                    "Modules/Main/SuiteScript2/Inspiredrooms.ei1.Main.Service.ss"
                ), true
            )
        }
    }
 
    InspiredroomsModel.prototype = Object.create(SCModel.prototype);
    InspiredroomsModel.prototype.constructor = InspiredroomsModel;
 
    return InspiredroomsModel
})
